
    import {IPage} from "@/js/page";
    import {Component, Vue, Watch} from "vue-property-decorator";
    const {regionData, CodeToText} =require("@/js/region/region");
    import {standardPublicApi} from "@/api/standard";
    import {authorizeCertApi, userApi} from "@/api/organization";
    import baseUrl, {imageUrl} from "@/constants";
    import SetTableColumns from "@/components/SetTableColumns.vue"
    import TableShowRangeBody from "@/components/table-show-range-body.vue";
    import TableShowRangeHead from "@/components/table-show-range-head.vue";
    @Component({
        name: "standardList",
        components: {TableShowRangeHead, SetTableColumns, TableShowRangeBody}
    })
    export default class Home extends Vue {
        title = "社会公用计量标准";
        listData = [];
        regionData = regionData;
        CodeToText = CodeToText;
        private closePage: any;
        private exportExcel: any;
        listParam: IPage = {
            size: 10,
            current: 1,
        };
        propParams = {
            name: '',//名称
            status: '',// 状态 0:待提交 1:未审核  2:已生效  3:未通过
            useStatus: '',//使用状态：1.在用 2.暂停 3.封存 4.撤销
            companyName: '', //建标单位
            certificateNo: '',//考核证书号
            issuingAuthority: '',//发证机关
            issuedDate: '',//发证日期
            region: '',//所在区域
            termValidity: '',//有效期
            issuedDateEnd: '',//发证日期结束
            termValidityEnd: '',//有效期结束
        };
        mode = 0; // 0: 本单位社会公用计量标准管理 1: 全部社会公用计量标准信息 2 社会公用计量标准审核
        listTotal = 0;
        screenHeight = document.documentElement.clientHeight; // 可见区域高度(应为body高度，可某些环境下无法获取)
        tabCol = [];
        allSelected = [];
        load = false;
        showForm = false;
        sysPublicUpdate = false;
        exportAllSocialMeasuring = false;
        useUnitId = "";  //使用单位id
        tableKey = 0;
        fullScreen = false;

        created() {
            const route = this.$route;
            const q = JSON.parse(JSON.stringify(route.query));
            if (q.size) {
                this.listParam.size = Number(q.size);
                this.listParam.current = Number(q.current);
            }
            if(this.$route.params.useUnitId){
                this.useUnitId = this.$route.params.useUnitId as string;
            }
            if(route.path.indexOf('external') !== -1){
                this.fullScreen = true;
            }

            this.mode = Number(this.$route.params.mode);
            this.getConfig();
            this.haveRight();
        }
        activated(){
            if (this.$route.meta && !this.$route.meta.isBack) {
                this.showForm = false;
                this.reset();
            }else{
                this.list();
            }
            this.tableClearSelect();
        }
        tableClearSelect(){
            this.allSelected = [];
            let $table = this.$refs.table as HTMLFormElement;
            if($table){
                $table.clearSelection();
            }
        }

        parseParamList(jsonString: string){
            if(jsonString){
                return JSON.parse(jsonString);
            }
        }

        haveRight(){
            const right = this.$store.state.userRights;
            right.forEach((e:any)=>{
                if(e.name == "社会公用计量标准审核"){
                    this.sysPublicUpdate = true;
                }else if(e.name == "export_all_social_measuring"){
                    this.exportAllSocialMeasuring = true;
                }
            })
        }
        getConfig() {
            userApi.getUserConfig({name: "publicListPageSize"}).then(r => {
                if (r.data.result == 0) {
                    const rData = r.data.data;
                    if (rData) {
                        this.listParam.size = Number(rData.config);
                    }
                    this.list();
                }
            })
        }

        memberSelect(selection: any, row: any) {
            this.allSelected = selection;
        }

        changeTabCol(e: any) {
            this.tabCol = e;
            this.$nextTick(()=>{
                let $table = this.$refs.table as HTMLFormElement;
                if($table){
                    $table.doLayout();
                }
                this.tableKey = Math.random();
            })
        }

        add() {
            this.$router.push("/sg/standard/publicDetail/0/0/" +  this.mode);
        }

        edit(row: any, type: number) {
            this.$router.push("/sg/standard/publicDetail/" + row.id + "/" + type + "/" + this.mode);
        }

        batchRevoke(dataArr: any){
            this.$confirm('确定要撤销社会公用计量标准名称为:  ' + dataArr.flatMap((e: any) => e.name).join(",") + '？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                dangerouslyUseHTMLString: true
            }).then(() => {
                authorizeCertApi.updateStatus({ids: dataArr.flatMap((e: any) => e.id).join(","), status: 0, reason: '', type: 2}).then(r => {
                    if (r.data.result === 0) {
                        this.$message.success("撤销成功");
                        this.list();
                    }
                })
            }).catch(() => {
                console.log("取消")
            });
        }

        batchSubmit(dataArr: any){
            this.$confirm('确定要提交社会公用计量标准名称为:  ' + dataArr.flatMap((e: any) => e.name).join(",") + '？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                dangerouslyUseHTMLString: true
            }).then(() => {
                authorizeCertApi.updateStatus({ids: dataArr.flatMap((e: any) => e.id).join(","), status: 1, reason: '', type: 2}).then(r => {
                    if (r.data.result === 0) {
                        this.$message.success("提交成功");
                        this.list();
                    }
                })
            }).catch(() => {
                console.log("取消")
            });
        }
        //0新增  1编辑 2查看  3删除
        toDetail(type: number) {
            const dataArr = this.allSelected as any;
            let id = 0;
            if (type !== 0) {
                if (dataArr.length == 0) {
                    this.$message.error("请先勾选");
                    return;
                }
                if(type === 6){
                    this.batchRevoke(dataArr);
                    return;
                }

                if (dataArr.length > 1 && (type == 1 || type == 2 || type == 4)) {
                    this.$message.error("只能勾选一条");
                    return;
                }

                if(type == 3){
                    const data = dataArr.filter((d: any) => d.status.value === 2);
                    if(data.length > 0){
                        const names = data.flatMap((e: any) => e.name).join(",");
                        this.$message.error("您选择的 【" + names+ "】已通过，无法进行删除！");
                        return;
                    }
                }
                if(type == 5){
                    const data = dataArr.filter((d: any) => d.status.value === 2);
                    if(data.length > 0){
                        const names = data.flatMap((e: any) => e.name).join(",");
                        this.$message.error("您选择的 【" + names+ "】已通过，无法进行提交！");
                        return;
                    }
                }

                if (type == 3) {
                    this.delete(dataArr);
                    return;
                }

                if (type == 5){
                    this.batchSubmit(dataArr);
                    return;
                }

                id = dataArr[0].id;
            }
            const firstRouterText = this.$route.path.split("/")[1];
            this.$router.push("/" + firstRouterText + "/standard/publicDetail/" + id + "/" + type + "/" + this.mode);
        }


        down(row: any) {
            try {
                var obj=JSON.parse(row);
                if(typeof obj == 'object' && obj ){
                    window.open(baseUrl + "/file/download?file=" + obj[0].url + "&name=" + obj[0].name, '_blank');
                    return true;
                }else{
                    return false;
                }
            } catch(e) {
                window.open(baseUrl + "/file/download?file=" + row + "&name=社会公用计量标准证书影印件", '_blank');
                return false;
            }
        }

        list() {
            return new Promise(resolve => {
                const route = this.$route;
                let q = JSON.parse(JSON.stringify(route.query));
                q = Object.assign(q, this.listParam);
                for (const key in q) {
                    q[key] = String(q[key]);
                }
                const params = {
                    ...this.listParam,
                    ...this.propParams,
                    mode: this.mode === 2 ? 1 : this.mode,
                    useUnitId: this.useUnitId,
                }as any;

                if(this.mode == 1){
                    params.status = 2;
                }else if(this.mode === 2){
                    params.status = 1;
                }
                this.load = false;
                standardPublicApi.page(params).then(r => {
                    if (r.data.result === 0) {
                        const rData = r.data.data.records;
                        this.listTotal = r.data.data.total;
                        this.listData = rData;
                    }
                    this.$nextTick(() => {
                        this.load = true;
                        let $table = this.$refs.table as HTMLFormElement;
                        if($table){
                            $table.doLayout();
                        }
                        resolve(1);
                    })
                })
            })
        }

        pageSizeChange(val: number) {
            this.listParam.size = val;
            this.refresh();
            userApi.updateUserConfig({name: "publicListPageSize", config: val})
        }

        pageCurrentChange(val: number) {
            this.listParam.current = val;
            this.list();
        }

        checkboxInit(row: any, index: number) {
            if (row.result) {
                return 0;//0不可勾选
            } else {
                return 1;//1可勾选
            }
        }

        indexMethod(index: any) {
            return (this.listParam.current - 1) * this.listParam.size + index + 1;
        }

        refresh() {
            this.listParam.current = 1;
            this.list();
        }
        reset() {
            this.propParams.name = '';//名称
            this.propParams.status = '';//状态
            this.propParams.useStatus = '';//使用状态
            this.propParams.companyName = '';//建标单位
            this.propParams.region = ''; //所在区域
            this.propParams.certificateNo = '';//考核证书号
            this.propParams.issuingAuthority = '';//发证机关
            this.propParams.issuedDate = '';//发证日期
            this.propParams.termValidity = '';//有效期
            this.propParams.issuedDateEnd = '';//发证日期结束
            this.propParams.termValidityEnd = '';//有效期结束
            this.refresh();
        }
        // @Watch("$route.path")
        // get$routePath() {
        //     this.mode = Number(this.$route.params.mode);
        //     this.refresh();
        // }

        delete(dataArr: any) {
            this.$confirm('确定要删除社会公用计量标准名称为:  ' + dataArr.flatMap((e: any) => e.name).join(",") + '？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                dangerouslyUseHTMLString: true
            }).then(() => {
                standardPublicApi.delete({ids: dataArr.flatMap((e: any) => e.id).join(",")}).then(r => {
                    if (r.data.result === 0) {
                        this.$message.success("删除成功");
                        this.allSelected = [];
                        this.listParam.current = 1;
                        this.refresh();
                    }
                })
            }).catch(() => {
                console.log("取消")
            });
        }

        //导出
        onExportExcel() {
            const loading = this.$loading({
                text: '正在导出Excel',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            const listParam = JSON.parse(JSON.stringify(this.listParam));
            this.listParam.size = this.listTotal;    //将表格长度变成数据总长度
            this.listParam.current = 1;          //显示第一页
            this.list().then(() => {
                this.exportExcel(() => {
                    this.listParam = listParam;    //表格长度还原
                    this.list();
                    loading.close();
                },"社会公用计量标准列表.xlsx");
            });
        }
    }
